import { render } from "./Products.vue?vue&type=template&id=6caa449d&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=6caa449d&lang=scss&scoped=true"

import exportComponent from "D:\\local_sites\\svn_sandra\\outside_sales_system\\apps\\sales_visits_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6caa449d"]])

export default __exports__